import { render, staticRenderFns } from "./appCardActu.vue?vue&type=template&id=1cb5b504&scoped=true"
import script from "./appCardActu.vue?vue&type=script&lang=js"
export * from "./appCardActu.vue?vue&type=script&lang=js"
import style0 from "./appCardActu.vue?vue&type=style&index=0&id=1cb5b504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5b504",
  null
  
)

export default component.exports